import Vue from "vue";
import App from "./app.vue";
import iView  from 'view-design';
import { router } from './router/index';
 import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import 'view-design/dist/styles/iview.css';
import url from './lib/url'
Vue.prototype.$url = url;

// Vue.forceUpdate()
// import './theme.less';
import Ajax from './lib/ajax';
Vue.prototype.$Ajax = Ajax;
import Util from './lib/util';
import appconst from './lib/appconst'
Vue.prototype.$baseURL = appconst.remoteServiceBaseUrl
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
Vue.use(iView);
import fileTypeFilter from './utils/fileTypeFilter';
Vue.filter('fileType', fileTypeFilter);

// 定义常量
import constDefinition from './lib/constDefinition';
Vue.prototype.$constDefinition = constDefinition;

//滚动
import store from './store/index';
Vue.config.productionTip = false;
//轮播
import VueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(VueSeamlessScroll,{componentName: 'vue-seamless-scroll'})

//图片预览
import "viewerjs/dist/viewer.css"; //引入css的样式
import { api as viewerApi } from "v-viewer"
Vue.prototype.$viewerApi = viewerApi;

import {decryptData,security_EncriptResponse} from './utils/encData/index.js'
Vue.prototype.$decryptData = decryptData;
Vue.prototype.$security_EncriptResponse = security_EncriptResponse

import Viewer from 'v-viewer'
 Vue.use(Viewer)
//拖拽改变顺序
import VueDND from 'awe-dnd'
Vue.use(VueDND);
// * 下载导出
import downLoad from './utils/downLoad/index'
Vue.prototype.$downLoad = downLoad;
// * 导出
import { excelExport } from '@/lib/excelExportHook'
Vue.prototype.$excelExport = excelExport;
import progressBar from './components/progress-bar/index.vue'
export default {
    install(Vue) {
     Vue.component("progress-bar", progressBar);
    }
};
Vue.component("progress-bar", progressBar);
import { appRouters, otherRouters } from "./router/router";
if (!abp.utils.getCookieValue("Abp.Localization.CultureName")) {
  let language = navigator.language;
  abp.utils.setCookieValue(
    "Abp.Localization.CultureName",
    language,
    new Date(new Date().getTime() + 5 * 365 * 86400000),
    abp.appPath
  );
}

//定义全局 时间过滤器
import moment from "moment";
Vue.prototype.$moment = moment;
//  全局过滤器 时间戳 
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm') {

  if (dataStr) {
    return moment(dataStr).format(pattern)
  } else {
    return dataStr
  }
})
if (!String.prototype.endsWith) {
    //判断String这个对象原型是否有endsWith方法，没有的话，就用加上这个方法
    Object.defineProperty(String.prototype, 'endsWith', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function (searchString, position) {
            position = position || this.length;
            position = position - searchString.length;
            var lastIndex = this.lastIndexOf(searchString);
            return lastIndex !== -1 && lastIndex === position;
        },
    });
}

Ajax.get("/AbpUserConfiguration/GetAll").then((data) => {
  Util.abp = Util.extend(true, Util.abp, data.data.result);
  new Vue({
    render: (h) => h(App),
    router: router,
    store: store,
    data: {
      currentPageName: "",
    },
    async mounted() {
      this.currentPageName = this.$route.name as string;
      await this.$store.dispatch({
        type: "session/init",
      });
      if (
        !!this.$store.state.session.user &&
        this.$store.state.session.application.features["SignalR"]
      ) {
        if (
          this.$store.state.session.application.features["SignalR.AspNetCore"]
        ) {
          SignalRAspNetCoreHelper.initSignalR();
        }
      }
      this.$store.commit("app/initCachepage");
      this.$store.commit("app/updateMenulist");
    },
    created() {
      let tagsList: Array<any> = [];
      appRouters.map((item) => {
        if (item.children.length <= 1) {
          tagsList.push(item.children[0]);
        } else {
          tagsList.push(...item.children);
        }
      });
      this.$store.commit("app/setTagsList", tagsList);
    },
  }).$mount("#app");
});
